// @flow
import * as React from "react";
import { createCache, createResource } from "simple-cache-provider";
import Spinner from "../Spinners/BrandSpinner";

class DeadlineAwareCacheConsumer extends React.Component<
  {
     resource: *,
     cache: *,
     preload?: Array<string>,
     children: ({ get: string => mixed }) => React.Node
  },
  {
    pastDeadline: boolean,
    pastPendingThreshold: boolean
  }
> {
  state = {
    pastDeadline: false,
    pastPendingThreshold: false
  };

  available = false;
  suspender = null;

  trackDeadlines() {
    setTimeout(() => {
      // Типа если через секунду зарезолвимся, то можно не потеть
      if (this.available && this.suspender != null) {
        this.setState(
          {
            pastDeadline: true
          },
          () => {
            setTimeout(() => {
              if (this.available) {
                this.setState(state => {
                  if (state.pastDeadline) {
                    return {
                      pastPendingThreshold: true
                    };
                  } else {
                    return null;
                  }
                });
              }
            }, 1000);
          }
        );
      }
    }, 1000);
  }

  componentDidMount() {
    this.available = true;

    if (this.suspender != null) {
      this.trackDeadlines();
    }
  }

  componentWillUnmount() {
    this.available = false;
  }

  render() {
    if (this.props.preload != null) {
      for (const key of this.props.preload) {
        this.props.resource.preload(this.props.cache, key);
      }
    }

    let rendered = null;

    if (this.suspender == null) {
      try {
        rendered = this.props.children({
          get: key => {
            return this.props.resource.read(this.props.cache, key);
          }
        });

        if (this.state.pastDeadline && !this.state.pastPendingThreshold) {
          return <Spinner />;
        } else {
          return rendered;
        }
      } catch (thing) {
        if (typeof thing === "object" && typeof thing.then === "function") {
          this.suspender = thing.then(
            () => {
              this.suspender = null;
              this.forceUpdate();
            },
            () => {
              this.suspender = null;
              this.forceUpdate();
            }
          );

          if (this.state.pastDeadline) {
            return <Spinner />;
          } else {
            return <Spinner />; // TODO: дождаться Suspense в реакте
          }
        } else {
          throw thing;
        }
      }
    } else {
      if (this.state.pastDeadline) {
        return <Spinner />;
      } else {
        return <Spinner />; // TODO: дождаться Suspense в реакте
      }
    }
  }
}

export default function createReactCache(options) {
  const resource = createResource(options.load);

  const cache = createCache();
  const CacheContext = React.createContext(cache);

  function CacheConsumer(props) {
    return (
      <CacheContext.Consumer>
        {cache => (
          <DeadlineAwareCacheConsumer
            cache={cache}
            resource={resource}
            preload={props.preload}
            children={props.children}
          />
        )}
      </CacheContext.Consumer>
    );
  }

  return {
    Provider: CacheContext.Provider,
    Consumer: CacheConsumer
  };
}



// WEBPACK FOOTER //
// ./src/components/common/experimental_dataSource.js